import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import app from './firebase';
import Header from './components/Header';
import Home from './components/Home';
import Privacy from './components/Privacy';
import Terms from './components/Terms';
import AdminLogin from './components/AdminLogin';
import AdminDashboard from './components/AdminDashboard';
import PrivacyConsent from './components/PrivacyConsent';
import SensitiveInfoConsent from './components/SensitiveInfoConsent';
import MarketingConsent from './components/MarketingConsent';
import './App.css';

function App() {
  const [user, setUser] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const auth = getAuth(app);
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        // 관리자 권한 확인
        const isAdminUser = user.email.endsWith('@tobeai.xyz') ||
          user.email === 'admin@tobeai.xyz';
        setUser(user);
        setIsAdmin(isAdminUser);
      } else {
        setUser(null);
        setIsAdmin(false);
      }
      setIsLoading(false);
    });

    return () => unsubscribe();
  }, []);

  const handleLoginSuccess = (user) => {
    setUser(user);
    setIsAdmin(true);
  };

  const handleLogout = () => {
    setUser(null);
    setIsAdmin(false);
  };

  if (isLoading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontSize: '1.2rem',
        color: '#6c757d'
      }}>
        로딩 중...
      </div>
    );
  }

  return (
    <Router>
      <div className="App">
        {/* 관리자 페이지는 헤더 없이 */}
        {!isAdmin ? (
          <>
            <Header />
            <Routes>
              <Route path="/" element={<Home />} />
              {/* <Route path="/contact" element={<Contact />} /> */}
              {/* <Route path="/faq" element={<FAQ />} /> */}
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/privacy-consent" element={<PrivacyConsent />} />
              <Route path="/sensitive-info-consent" element={<SensitiveInfoConsent />} />
              <Route path="/marketing-consent" element={<MarketingConsent />} />
              <Route path="/admin" element={
                user ? <Navigate to="/admin/dashboard" /> : <AdminLogin onLoginSuccess={handleLoginSuccess} />
              } />
              <Route path="/admin/dashboard" element={
                isAdmin ? <AdminDashboard user={user} onLogout={handleLogout} /> : <Navigate to="/admin" />
              } />
              <Route path="*" element={<Navigate to="/" />} />
            </Routes>
          </>
        ) : (
          <Routes>
            <Route path="/admin/dashboard" element={
              <AdminDashboard user={user} onLogout={handleLogout} />
            } />
            <Route path="*" element={<Navigate to="/admin/dashboard" />} />
          </Routes>
        )}
      </div>
    </Router>
  );
}

export default App;
